export default __webpack_public_path__ + "dd6dda503e2662c2186eecf2555c6c93.svg";